export default "__VITE_ASSET__7Szrmgvg__"